import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Menu from '../../components/Menu/Menu';
import Footer from '../../components/Footer';
import Pagination from '../../components/Pagination';
import { getAllStrategies, deleteStrategy, getOrphanStrategies, deleteOrphanStrategies } from '../../services/StrategiesService';
import Toast from '../../components/Toast';
import StrategyRow from './StrategyRow';

function Strategies() {

    const defaultLocation = useLocation();

    const [strategies, setStrategies] = useState([]);
    const [count, setCount] = useState(0);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(getPage());
    const [notification, setNotification] = useState({ type: '', text: '' });
    const [orphanCount, setOrphanCount] = useState(0);

    function getPage(location) {
        if (!location) location = defaultLocation;
        return new URLSearchParams(location.search).get('page');
    }

    useEffect(() => {
        setPage(getPage(defaultLocation));
    }, [defaultLocation])

    useEffect(() => {
        getAllStrategies(page || 1, search)
            .then(result => {
                setStrategies(result.rows || []);
                setCount(result.count || 0);
            })
            .catch(err => {
                console.error(err.response ? err.response.data : err.message);
                setNotification({ type: 'error', text: err.response ? err.response.data : err.message });
            });

        // Verificar estratégias órfãs
        getOrphanStrategies()
            .then(result => {
                setOrphanCount(result.count || 0);
            })
            .catch(err => {
                // Ignora erros ao verificar órfãs
                console.error('Erro ao verificar estratégias órfãs:', err);
            });

    }, [page, search])

    function onSearchChange(event) {
        setSearch(event.target.value);
        setPage(1);
    }

    function onDeleteClick(event) {
        const id = event.target.id.replace('delete', '');
        const strategy = strategies.find(s => s.id == id);
        const strategyName = strategy ? `${strategy.name} (${strategy.symbol})` : `ID ${id}`;
        const userName = strategy?.user?.name || 'N/A';
        
        if (!window.confirm(`Tem certeza que deseja deletar a estratégia "${strategyName}" do usuário "${userName}"?\n\nEsta ação irá deletar:\n- A estratégia\n- As automações de compra e venda\n- Os templates de ordem\n- O monitor\n\nEsta ação não pode ser desfeita!`)) {
            return;
        }

        deleteStrategy(id)
            .then(() => {
                setNotification({ type: 'success', text: `Estratégia "${strategyName}" deletada com sucesso!` });
                window.location.reload();
            })
            .catch(err => {
                console.error(err.response ? err.response.data : err.message);
                setNotification({ type: 'error', text: err.response ? err.response.data : err.message });
            });
    }

    function onCleanOrphansClick() {
        if (!window.confirm(`Tem certeza que deseja deletar ${orphanCount} estratégia(s) órfã(s)? Esta ação não pode ser desfeita.`)) {
            return;
        }

        deleteOrphanStrategies()
            .then(result => {
                setNotification({ 
                    type: 'success', 
                    text: `${result.deletedCount || 0} estratégia(s) órfã(s) deletada(s) com sucesso!` 
                });
                window.location.reload();
            })
            .catch(err => {
                console.error(err.response ? err.response.data : err.message);
                setNotification({ 
                    type: 'error', 
                    text: err.response ? err.response.data : err.message 
                });
            });
    }

    return (
        <>
            <Menu />
            <main className="content">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                    <div className="d-block mb-4 mb-md-0">
                        <h2 className="h4">Estratégias de Usuários</h2>
                    </div>
                    <div className="btn-toolbar mb-2 mb-md-0">
                        <div className="btn-group">
                            <input 
                                type="text" 
                                className="form-control" 
                                placeholder="Buscar por usuário, símbolo ou nome..." 
                                value={search}
                                onChange={onSearchChange}
                            />
                        </div>
                    </div>
                </div>
                {
                    orphanCount > 0 && (
                        <div className="alert alert-warning d-flex justify-content-between align-items-center mb-3" role="alert">
                            <div>
                                <strong>Atenção!</strong> Existem {orphanCount} estratégia(s) órfã(s) no sistema. 
                                Estas estratégias podem estar causando problemas.
                            </div>
                            <button 
                                className="btn btn-warning btn-sm" 
                                onClick={onCleanOrphansClick}
                            >
                                Limpar Estratégias Órfãs
                            </button>
                        </div>
                    )
                }
                <div className="card card-body border-0 shadow table-wrapper table-responsive">
                    <table className="table table-hover">
                        <thead>
                            <tr>
                                <th className="border-gray-200">Usuário</th>
                                <th className="border-gray-200">Email</th>
                                <th className="border-gray-200">Símbolo</th>
                                <th className="border-gray-200">Nome</th>
                                <th className="border-gray-200">Status</th>
                                <th className="border-gray-200">Iniciada em</th>
                                <th className="border-gray-200">Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                strategies && strategies.length
                                    ? strategies.map(strategy => (
                                        <StrategyRow 
                                            key={strategy.id} 
                                            data={strategy} 
                                            onDeleteClick={onDeleteClick} 
                                        />
                                    ))
                                    : <tr><td colSpan="7" className="text-center">Nenhuma estratégia encontrada</td></tr>
                            }
                        </tbody>
                    </table>
                    <Pagination count={count} />
                </div>
                <Footer />
            </main>
            <Toast type={notification.type} text={notification.text} />
        </>
    );
}

export default Strategies;

